var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExecutive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.95,
    y1: -0.728,
    x2: 2.785,
    y2: 1.653,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#9a00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1718ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.535,
    y1: -5.72,
    x2: 0.834,
    y2: 2.513,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.061,
    y1: -2.223,
    x2: 0.954,
    y2: 1.293,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.235,
    y1: -2.515,
    x2: 0.781,
    y2: 0.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 44.843,
    y1: 17.251,
    x2: 49.578,
    y2: 19.633,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 13.712,
    y1: 60.256,
    x2: 15.082,
    y2: 68.489,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 20.883,
    y1: 25.497,
    x2: 22.899,
    y2: 29.002,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 20.71,
    y1: 25.999,
    x2: 22.726,
    y2: 29.504,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(-282 -4633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(282.5 4633.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141_00000034811631961770787510000005028115002720698261_",
    width: 12.9,
    height: 44.6,
    transform: "translate(17.5 33.9)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000111871553608085130680000018432854714215158173_",
    width: 44.6,
    height: 12.9,
    transform: "translate(17.5 74.4)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143_00000166655874111790034880000014228786822994583199_",
    d: "M39.4,69l9.1-9L69.7,81.2l-9.1,9Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_144_00000140731138984401260660000015604151543886972592_",
    d: "M39.4,93.3,60.6,72.1l9.1,9.1L48.5,102.4Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141_00000126314390253757255870000002559107849740799154_",
    width: 12.9,
    height: 44.6,
    transform: "translate(76.9 29.8)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142_00000182517687716149180470000007242176548203246777_",
    width: 44.6,
    height: 12.9,
    transform: "translate(45.1 21.1)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143_00000100370885265985963450000002507504103278566575_",
    d: "M67.8,39.3l-9.1,9.1L37.5,27.2l9.1-9.1Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_144_00000114060010360252369590000013669262030761101487_",
    d: "M67.8,15,46.6,36.2l-9.1-9.1L58.7,5.9Z",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 108,
    height: 108,
    transform: "translate(282 4633)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutive);
export default __webpack_public_path__ + "static/media/executive.5e953217a5827ce98b8a93f2606abf75.svg";
export { ForwardRef as ReactComponent };